import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [];
  }
 
  initialize(){
  this.submit_remote = _.debounce(this.submit_remote, 500);

  }

  submit(e){
    e.target.form.submit(); 
  }

  submit_remote(e) {
   Rails.fire(e.target.form, 'submit' )
   
  }
}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/submit_on_select_controller.js